import React, { useEffect, useState } from 'react'
import { Box, Typography } from "@mui/material";

const PasswordStrength = ({ password, style, sx }) => {
    const [strength, setStrength] = useState(0)
    const [passwordProgressColor, setPasswordProgressColor] = useState("#d3d3d3")

    const checkStrength = (password) => {
        let strength = 0
        const num = /\d/.test(password)
        const specialChars = /[_!@#$&*]/.test(password)
        const upperCase = /[A-Z]/.test(password)
        const lowerCase = /[a-z]/.test(password)

        if (password.length > 12 && upperCase && lowerCase && num && specialChars) {
            strength = 5
            setPasswordProgressColor('green')
        }
        else if (password.length > 8 && upperCase && lowerCase && num && specialChars) {
            strength = 4
            setPasswordProgressColor("#14eb6e")
        }
        else if ((password.length >= 8 && lowerCase && num && specialChars) || (password.length >= 8 && upperCase && num && specialChars)) {
            strength = 3
            setPasswordProgressColor("#4285f4")
        }
        else if ((password.length >= 8 && lowerCase && num) || (password.length >= 8 && upperCase && num)) {
            strength = 2
            setPasswordProgressColor('orange')
        }
        else if (password.length >= 8) {
            strength = 1
            setPasswordProgressColor("#ff3e00")
        }
        else {
            strength = 0
            console.log("🚀  file: PasswordStrength.js:46  checkStrength ~ strengthStatus:", strength)
        }
        // console.log("🚀  file: SignUp.js:147  format ~ strengthStatus:", strengthStatus && strengthStatus == 1 ? "weak" : strengthStatus == 2 ? "medium" : strengthStatus == 3 ? "good" : strengthStatus == 4 ? "strong" : strengthStatus == 5 ? "very strong" : null)
        return strength
    }


    useEffect(() => {
        setStrength(checkStrength(password))
    }, [password])
    return (

        <Box sx={{ bottom: { xs: -5, sm: -3, lg: -10 }, left: 35, display: "flex", alignItems: "center", gap: .5, justifyContent: "end", right: 2, ...sx }} style={style}>
            {[1, 2, 3, 4, 5].map(num => {
                return (
                    <Box sx={{ height: 3, borderRadius: 10, width: 20, backgroundColor: strength >= num ? passwordProgressColor : "#d3d3d3" }} />
                )
            })}

        </Box>

    )
}

export default PasswordStrength

PasswordStrength.defaultProps = {
    style: {},
    sx: {}
}
